/**
 * Hydrates bundle included items from Shopify native bundle components when
 * custom.bundle_data is not available in Liquid.
 */

function getStorefrontConfig() {
  const cfg = window.PB_UNIFIED_CART || window.Shopify?.storefront || {};

  return {
    endpoint: cfg.endpoint || cfg.storefrontApiUrl,
    token: cfg.token || cfg.storefrontAccessToken,
  };
}

function variantGid(id) {
  const value = String(id || '');

  return value.startsWith('gid://') ? value : `gid://shopify/ProductVariant/${value.replace(/\D/g, '')}`;
}

function cleanProductTitle(title) {
  return String(title || 'Item').trim();
}

async function fetchVariantComponents(variantId) {
  const cfg = getStorefrontConfig();

  if (!cfg.endpoint || !cfg.token) {
    throw new Error('Missing Storefront API config');
  }

  const response = await fetch(cfg.endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': cfg.token,
    },
    body: JSON.stringify({
      query: `
        query BundleIncludedItems($id: ID!) {
          node(id: $id) {
            ... on ProductVariant {
              components(first: 30) {
                nodes {
                  quantity
                  productVariant {
                    title
                    product {
                      title
                    }
                  }
                }
              }
            }
          }
        }
      `,
      variables: { id: variantGid(variantId) },
    }),
  });

  const json = await response.json();

  if (json.errors) {
    throw new Error(JSON.stringify(json.errors));
  }

  return json.data?.node?.components?.nodes || [];
}

function renderListItems(list, nodes) {
  list.innerHTML = '';

  nodes.forEach((node) => {
    const pv = node.productVariant || {};
    const product = pv.product || {};
    const title = cleanProductTitle(product.title || pv.title);
    const variantTitle = pv.title || '';
    const showVariant =
      variantTitle && variantTitle.toLowerCase() !== 'default title' && variantTitle !== title;
    const label = showVariant ? `${title} (${variantTitle})` : title;
    const qty = Number(node.quantity || 1);

    const item = document.createElement('li');
    item.className = 'bundle-included-items__item';
    item.textContent = `${qty}x ${label}`;
    list.appendChild(item);
  });
}

async function hydrateNativeBlock(block) {
  const variantId = block.dataset.variantId;
  const list = block.querySelector('[data-bundle-included-items-list]');

  if (!variantId || !list) return;

  try {
    const nodes = await fetchVariantComponents(variantId);

    if (!nodes.length) {
      block.remove();
      return;
    }

    renderListItems(list, nodes);
    list.hidden = false;
  } catch (error) {
    console.error('[BundleIncludedItems]', error);
    block.remove();
  }
}

function init(root = document) {
  root.querySelectorAll('[data-bundle-included-items-native]').forEach((block) => {
    if (block.dataset.bundleIncludedItemsReady === 'true') return;
    block.dataset.bundleIncludedItemsReady = 'true';
    hydrateNativeBlock(block);
  });
}

init(document);
document.addEventListener('DOMContentLoaded', () => init(document));
document.addEventListener('shopify:section:load', (event) => init(event.target || document));
document.addEventListener('bundle-sibling:changed', () => init(document));
